import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import theme from '../../themes/main';
import { isIE } from '../../utils/helper';

export const FormContainer = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${breakpoint('tablet')`
    width: 80%;
  `}
`;

export const ElementContainer = styled.div`
  align-items: center;
  color: ${theme.palette.blueGrey};
  display: flex;
  font-weight: 300;
  flex-direction: column;
  justify-content: space-between;
  letter-spacing: 0.025em;
  margin: 10px 0 20px 0;
  ${() => isIE() ? `width: 25%;` : `width: 100%;`}

  & > label {
    display: flex;
    align-items: flex-start;
    text-align: left;
    margin-bottom: 0.5rem;
    max-width: 500px;
    width: 100%;

    & > span.required-mark {
      color: ${theme.palette.red};
      display: block;
      margin-left: 0.2rem;
    }
  }

  & > div {
    align-items: flex-start;
    flex-direction: column;
    margin: 0;
    width: 100%;
    max-width: 500px;

    & > input {
      width: calc(100% - 28px);
    }
  }

  ${breakpoint('tablet')`
    width: initial;

    &.card-number {
      width: 100%
    }

    &.exp-element {
      margin-right: 1rem;
      width: 74%;
    }
    &.cvc-element {
      width: 20%;
    }
  `}

  ${breakpoint('desktop')`
    &.card-number {
      margin-right: 1rem;
      width: 46%;
    }
    
    &.exp-element {
      margin-right: 1rem;
      width: 36%;
    }
  `}
`;

export const InnerContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 0 0 10px;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  ${() => isIE() ? `margin-top: 1.5rem;` : ''}

  ${breakpoint('tablet')`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  `}

  ${breakpoint('desktop')`
    flex-wrap: nowrap;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/StripePaymentForm/styledComponents.js